import SectionStartTemplate from '../../../templates/sectionStart';
import { SectionStatus } from '../../../sections/types';

import { useCustomNavigate } from '../../../../hooks/useCustomNavigate';
import { Text } from '@chakra-ui/react';
import { useTranslation } from "react-i18next";

export interface IProps {
  personalInfoStatus: SectionStatus;
  consentsStatus: SectionStatus;
  financeStatus: SectionStatus;
}
type Props = IProps;

const HistorySectionStart = (props: Props) => {
    const { t } = useTranslation('common');
  const { navigateBackward, navigateForward, navigateToStudentDashboard } = useCustomNavigate();

  const onPrevious = () => navigateBackward();
  const onNext = () => navigateForward();
  const onBackToTaskList = () => navigateToStudentDashboard();

  return (
    <SectionStartTemplate
      section="Section 2 - Your History"
      minsToComplete={10}
      section1={props.personalInfoStatus}
      section2={SectionStatus.todo}
      section3={props.consentsStatus}
      section4={props.financeStatus}
      onNext={onNext}
      onPrevious={onPrevious}
      onBackToTaskList={onBackToTaskList}
    >
      <Text fontSize={'lg'}>
        {t('common:questionsWillCoverYourTravelAndA')}
                    </Text>
    </SectionStartTemplate>
  );
};

export default HistorySectionStart;
